var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingBuilding } from "../../balancingSelectors/selectBalancingBuildings";
import { selectResourceAmountInfo } from "../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../less/IdStyles";
import { selectXpInfo } from "../../selectors/selectXpInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilPager } from "../../utils/utilPager";
import { ButtonPagerLeft } from "../generic/common/ButtonPagerLeft";
import { ButtonPagerRight } from "../generic/common/ButtonPagerRight";
import { IconBuilding } from "../generic/common/icon-building/IconBuilding";
import { IdIconBuildingContext } from "../generic/common/icon-building/IdIconBuildingContext";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { Pager } from "../generic/pager/Pager";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { DialogGenericLevelUp } from "./DialogGenericLevelUp";
var MenuLevelUpDOM = /** @class */ (function (_super) {
    __extends(MenuLevelUpDOM, _super);
    function MenuLevelUpDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.RewardsPerPage = 3;
        _this.getPager = function () {
            var rewards = _this.props.rewards;
            var pageCount = _this.getPageCount(rewards);
            return React.createElement(Pager, { pageCount: pageCount }, _this.renderPager);
        };
        _this.renderPager = function (page, changePage) {
            var _a = _this.props, rewards = _a.rewards, buildings = _a.buildings;
            var unlockedRewards = rewards.map(_this.renderRewardItem);
            var unlockedBuildings = buildings.map(_this.renderBuildingItem);
            var pageCount = _this.getPageCount(rewards);
            var shouldRenderPaginationButtons = pageCount > 1;
            var items = utilPager.getPageItemsFilled(unlockedRewards.concat(unlockedBuildings), page, _this.RewardsPerPage);
            return (React.createElement("div", { className: "level-up__rewards " + IdStyles.LevelUpDialogRewards },
                shouldRenderPaginationButtons && (React.createElement(ButtonPagerLeft, { onClick: function () { return changePage(page - 1); } })),
                React.createElement("div", { className: "flex flex__full h100" }, items),
                shouldRenderPaginationButtons && (React.createElement(ButtonPagerRight, { onClick: function () { return changePage(page + 1); } }))));
        };
        _this.renderRewardItem = function (reward, index) {
            return (React.createElement("div", { key: index, className: "level-up__rewards-item pos-rel" },
                React.createElement(Icon, { icon: reward.icon, styleId: IdStyles.IconExtraLarge }),
                React.createElement("div", { className: IdStyles.TextBoldAccent + " pos-abs bottom-0" },
                    React.createElement(NumberFormat, { amount: reward.amount }))));
        };
        _this.renderBuildingItem = function (unlockedBuilding, index) {
            var level = unlockedBuilding.level, buildingId = unlockedBuilding.buildingId;
            var name = selectBalancingBuilding(buildingId).name;
            return (React.createElement("div", { className: "level-up__rewards-item pos-rel", key: name + "_" + level },
                React.createElement(IconBuilding, { level: level, buildingName: name, context: IdIconBuildingContext.LevelUpReward }),
                React.createElement("div", { className: IdStyles.TextBoldAccent + " pos-abs bottom-0" },
                    React.createElement(TextLoca, { id: IdLoca.new }))));
        };
        return _this;
    }
    MenuLevelUpDOM.prototype.render = function () {
        var _a = this.props, level = _a.level, onClose = _a.onClose;
        var pager = this.getPager();
        return (React.createElement(DialogGenericLevelUp, { level: level, onClose: onClose },
            React.createElement("div", { className: "flex flex--guts " + IdStyles.LevelUpDialogRewardsWrapper }, pager)));
    };
    MenuLevelUpDOM.prototype.getPageCount = function (rewards) {
        return Math.ceil(rewards.length / this.RewardsPerPage);
    };
    return MenuLevelUpDOM;
}(React.Component));
var mapState = function (state) {
    var xpInfo = selectXpInfo(state);
    var _a = xpInfo.level, reward = _a.reward, unlockedItems = _a.unlockedItems, level = _a.level;
    var rewards = [];
    if (reward) {
        rewards = reward.map(function (_a) {
            var resourceId = _a.resourceId, amount = _a.amount;
            var resource = selectResourceAmountInfo(resourceId, amount);
            return {
                amount: resource.amount,
                icon: getResourceIcon(resource),
            };
        });
    }
    var unlockedBuildings = unlockedItems ? unlockedItems.unlockedBuilding || [] : [];
    return {
        buildings: unlockedBuildings,
        level: level,
        rewards: rewards,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.LevelUp)); },
}); };
export var MenuLevelUp = connect(mapState, mapDispatch)(MenuLevelUpDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/MenuLevelUp.tsx
// module id = 2964
// module chunks = 3